import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
  // <React.StrictMode> won't be used because the request will force te repeat `useInstagramFeed` 
  //  request, which is memory intensive.
);
